module.exports = __webpack_public_path__ + "img/data_download_homepage.58631820.png";